module.exports = __webpack_public_path__ + "static/media/dummySign.90ea3a4c.png";